import { DoubleArrow } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import ScrollSubHeader from '../../../../shared/styles/ScrollSubHeader'
import { IFilter } from '../../models/sliders'
import TypeFilter from './TypeFilter'
import { IconButton } from '@mui/material'

interface SliderHeaderFiltersProps {
  filters: IFilter
  handleChangeFilter: (id: number, type: number, categoryId: number | null, label: string) => void
}

export function SliderHeaderFilters({ filters, handleChangeFilter }: SliderHeaderFiltersProps) {
  const { t } = useTranslation(['global'])

  return (
    <>
      <ScrollSubHeader>
        <TypeFilter id={1} type={t('Sliders')} categories={[]} active={1 === filters.id} handleChangeFilter={handleChangeFilter} />
        <TypeFilter
          id={2}
          type={t('link')}
          categories={[
            { id: 3, name: t('top') },
            { id: 4, name: t('leftBottom') },
            { id: 5, name: t('rightBottom') }
          ]}
          active={[2, 3, 4, 5].includes(filters.id)}
          filterCategoryId={filters.id}
          handleChangeFilter={handleChangeFilter}
        />
        <TypeFilter id={6} type={t('internal')} categories={[]} active={6 === filters.id} handleChangeFilter={handleChangeFilter} />
        <IconButton
          sx={{
            position: 'absolute',
            right: 0,
            top: '17%',
            zIndex: 10,
            backgroundColor: 'white'
          }}
          className="buttonScroll"
        >
          <DoubleArrow />
        </IconButton>
      </ScrollSubHeader>
    </>
  )
}
